import React from 'react';

const BusinessUnitConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/workauthorization',
			component:React.lazy(() => import('./WorkAuthorization')) 
        }
	]
};

export default BusinessUnitConfig;